<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>ARNI SCHOOL OF BUSINESS MANAGEMENT & COMMERCE</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Business Studies</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>


<section class="pt-3">
    <div class="container">
        <h3 class="text-center text-primary">Courses</h3>
        <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Post Graduate</th>
                            <th class="time">Doctorate</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">Bachelor of Business Administration</td>
                            <td class="time">Master of Business Administration</td>
                            <td class="time">Ph.D Management</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="col-md-12 col-lg-12 col-sm-12">
                <div class="event-schedule-table table-responsive">
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="time">Under Graduate</th>
                            <th class="time">Post Graduate</th>
                            <th class="time">Diploma</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td class="time">BBA (Specialization)</td>
                            <td class="time">MBA (Retail Management)</td>
                            <td class="time">Diploma in Direct Selling</td>
                        </tr>
                        <tr>
                            <td class="time"></td>
                            <td class="time">Risk Reduction and Management</td>
                            <td class="time">Diploma on Disaster Risk Reduction and Management</td>
                        </tr>
                        <tr>
                            <td class="time"></td>
                            <td class="time"></td>
                            <td class="time">Diploma in Event Management</td>
                        </tr>
                        <tr>
                            <td class="time"></td>
                            <td class="time"></td>
                            <td class="time">Diploma in Digital Marketing</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <h5 class="text-decoration-underline text-center">Business Management & Commerce</h5>

        <div class="row">
            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Bachelor of Business Administration (BBA) </b>
                    – The Bachelor of Business Administration (BBA) program at ARNI School of Business Management &
                    Commerce is designed to develop future business leaders and entrepreneurs. This program provides
                    students with in-depth knowledge of business fundamentals, strategic decision-making, financial
                    management, and marketing principles. The BBA curriculum is divided into six semesters and includes
                    core subjects, electives, internships, and research projects.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b> : Foundation</p>
                <ul>
                    <li> Communication in English</li>
                    <li> Business Fundamentals</li>
                    <li> Financial Accounting</li>
                    <li> Micro Economics</li>
                    <li> Principles of Management</li>
                    <li> Quantitative Techniques</li>
                    <li> Introduction to Business and Entrepreneurship</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b> : Fundamentals</p>
                <ul>
                    <li> Design Tools for Businesses</li>
                    <li> Marketing and Communications Strategy</li>
                    <li> Macroeconomics</li>
                    <li> Business Analytics</li>
                    <li> Environmental Management</li>
                    <li> Marketing Techniques</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b> : Business Strategies</p>
                <ul>
                    <li> Banking and Insurance</li>
                    <li> Human Resource Management</li>
                    <li> Direct and Indirect Tax</li>
                    <li> Introduction to Operations Research</li>
                    <li> Corporate Finance</li>
                    <li> Sales and CRM</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b> : Technology & Innovations</p>
                <ul>
                    <li> Financial & Management Accounting</li>
                    <li> Leadership and Ethics</li>
                    <li> Personnel Management & Industry Relations</li>
                    <li> Business Laws and Valuation</li>
                    <li> Fundamentals of a D2C Business</li>
                    <li> Project</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5</b> : Specializations & Industry Exposure
                </p>
                <ul>
                    <li> Production & Material Management</li>
                    <li> Financial Management</li>
                    <li> Taxation Planning</li>
                    <li> Business Data Processing</li>
                    <li> Project Management</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6</b> : Projects and Career Readiness
                </p>
                <ul>
                    <li> International Trade Operations</li>
                    <li> Business Intelligence</li>
                    <li> Management of Funds</li>
                    <li> Consumer Behavior</li>
                    <li> Project/Seminar</li>
                    <li> Internships</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Master of Business Administration </b> –
                    The goal of the ARNI School of Business Management & Commerce's Master of Business Administration
                    (MBA) program is to cultivate future entrepreneurs and business executives. Skills in management,
                    marketing, finance, operations, and other fields will be developed through this curriculum.
                    Professionals who want to progress in their careers strongly value it. Core courses, electives,
                    internships, and research projects are all part of the four semesters that make up the MBA program.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b> : Foundation
                </p>
                <ul>
                    <li> Business Communication</li>
                    <li> Accounting for Managers</li>
                    <li> Business Environment and Law</li>
                    <li> Managerial Economics</li>
                    <li> Organizational Behavior</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b> : Fundamentals
                </p>
                <ul>
                    <li> Marketing Management</li>
                    <li> Financial Management</li>
                    <li> Human Resources Management</li>
                    <li> Strategic Management</li>
                    <li> Operations Research and Management</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b> : Business Strategies
                </p>
                <ul>
                    <li> Consumer Behavior</li>
                    <li> Entrepreneurship Management</li>
                    <li> Management Control Systems</li>
                    <li> Merchant Banking and Financial Services</li>
                    <li> Performance Management</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b> : Technology & Innovations
                </p>
                <ul>
                    <li> E-Business & Information Technology</li>
                    <li> International Business</li>
                    <li> Portfolio for Investment Management</li>
                    <li> Services Marketing</li>
                    <li> Development & Training</li>
                    <li> Project Work</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">MBA (Retail Management)</b> –
                    The Master of Business Administration in Retail Management (MBA) program at the ARNI School of
                    Business Management & Commerce aims to develop future business executives and entrepreneurs. Retail
                    store managers, regional managers, branch managers, institutional sales managers, service managers,
                    and other positions are available to MBA graduates in retail management. The four semesters that
                    comprise the MBA program include core courses, electives, internships, and research projects.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1</b>
                </p>
                <ul>
                    <li> Introduction of Retailing</li>
                    <li> Business Communication</li>
                    <li> Buying Merchandising</li>
                    <li> Retail Marketing</li>
                    <li> IT application in Retail</li>
                    <li> Store Operations I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2</b>
                </p>
                <ul>
                    <li> Principles of Marketing Economics</li>
                    <li> Customer Service Management</li>
                    <li> Retail Management Perspective</li>
                    <li> Human Resources Management</li>
                    <li> Corporate Legal Framework</li>
                    <li> Research Methodology for Management</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3</b>
                </p>
                <ul>
                    <li> Fundamentals of Retail Management</li>
                    <li> Retail Shoppers Behavior & CRM</li>
                    <li> Sales Force Management</li>
                    <li> Merchandise Management</li>
                    <li> Direct and Network Marketing</li>
                    <li> Intellectual Property Rights</li>
                    <li> Assignments /Project</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4</b>
                </p>
                <ul>
                    <li> HRM in Retailing</li>
                    <li> International Retailing</li>
                    <li> Retail Operations Management</li>
                    <li> Supply Chain Management</li>
                    <li> Project Report</li>
                    <li> Internship</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">MBA in Risk Reduction and Management</b> –
                    The MBA in Risk Reduction and Management at ARNI School of Business Management & Commerce is a
                    specialized program designed to equip professionals with the skills and expertise needed to assess,
                    mitigate, and manage risks across various industries. The MBA in Risk Reduction and Management
                    curriculum is divided into four semesters and includes core subjects, electives, case studies,
                    practical training, and a dissertation project.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1
                </b>: Foundations of Business & Risk Management
                </p>
                <ul>
                    <li>Principles of Management & Organizational Behavior</li>
                    <li> Business Communication & Negotiation Skills</li>
                    <li>Managerial Economics & Business Environment</li>
                    <li>Financial Accounting & Reporting</li>
                    <li> Introduction to Risk Management</li>
                    <li>Business Statistics & Data Analytics</li>
                    <li>Practical: Case Studies, Business Simulations</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2

                </b>: Strategic Risk Analysis & Financial Risk Management
                </p>
                <ul>
                    <li> Financial Risk Management & Insurance</li>
                    <li> Business Law & Corporate Governance</li>
                    <li> Risk Assessment & Mitigation Strategies</li>
                    <li> Operations & Supply Chain Risk Management</li>
                    <li>Investment & Portfolio Risk Management</li>
                    <li> Cybersecurity & IT Risk Management</li>
                    <li> Practical: Risk Audit Reports, Compliance Workshops</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3
                </b>: Crisis Management & Industry-Specific Risks
                </p>
                <ul>
                    <li> Disaster Risk Reduction & Crisis Response</li>
                    <li> Enterprise Risk Management (ERM) Frameworks</li>
                    <li> Legal & Regulatory Aspects of Risk Management</li>
                    <li> Environmental & Social Risk Management</li>
                    <li>Global Risk & Geopolitical Threats</li>
                    <li>Industry-Specific Risk Case Studies (Banking, Healthcare, Energy, Manufacturing)</li>
                    <li>Practical: Simulated Risk Scenarios, Corporate Risk Strategy Development</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4
                </b>: Advanced Risk Governance & Capstone Project
                </p>
                <ul>
                    <li>Strategic Decision-Making in Risk Management</li>
                    <li> Business Continuity Planning & Resilience Management</li>
                    <li>Artificial Intelligence & Technology in Risk Assessment</li>
                    <li> Leadership in Risk Management & Ethical Decision-Making</li>
                    <li> Dissertation/Research Project</li>
                    <li>Internship & Industry Exposure</li>
                    <li> Practical: Real-World Risk Consulting, Industry Research</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Ph.D Management </b> –
                    ARNI School of Management and Commerce offered PhD in Management. Human resources, operations,
                    finance, administration, sales and marketing, and other management topics are covered in the
                    curriculum to help students better grasp the various facets of corporate management. The course
                    lasts for three to six years and is broken up into six semesters.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1
                </b>
                </p>
                <ul>
                    <li> General Management</li>
                    <li> Research Methodology and IT</li>
                    <li> Preparation of Research Proposal and Seminar</li>
                    <li> Emerging Areas in Human Resource Management and Organizational Behavior</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2
                </b>
                </p>
                <ul>
                    <li> Emerging Areas in Marketing</li>
                    <li> Emerging Areas in Management</li>
                    <li> Information Technology Management</li>
                    <li> Operations management</li>
                    <li> Elective I</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 3
                </b>
                </p>
                <ul>
                    <li> Quantitative Analysis</li>
                    <li> Computer Applications</li>
                    <li> Progress Report/Presentation</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 4
                </b>
                </p>
                <ul>
                    <li> Project phase</li>
                    <li> Review report</li>
                    <li> Seminar</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 5
                </b>
                </p>
                <ul>
                    <li> Retail Merchandizing</li>
                    <li> Sales and Marketing</li>
                    <li> Logistics</li>
                </ul>
            </div>


            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 6
                </b>
                </p>
                <ul>
                    <li> Dissertation</li>
                    <li> Seminar</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Direct Selling </b> –
                    The Diploma in Direct Selling at ARNI School of Business Management & Commerce is designed to equip
                    students with the essential knowledge, skills, and strategies required to excel in the fast-growing
                    direct selling industry. This program provides in-depth insights into sales techniques, customer
                    relationship management, business ethics, and digital marketing strategies, empowering students to
                    build successful careers in direct selling and network marketing. The Diploma in Direct Selling
                    consists of two semesters, covering core subjects, practical training, and industry projects.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1
                </b>: Fundamentals
                </p>
                <ul>
                    <li> Introduction to Direct Selling & Network Marketing</li>
                    <li> Principles of Sales & Marketing</li>
                    <li> Consumer Behavior & Buying Psychology</li>
                    <li> Business Communication & Public Speaking Skills</li>
                    <li> Leadership & Team Management in Direct Selling</li>
                    <li> Customer Relationship Management (CRM)</li>
                    <li> Legal & Ethical Aspects of Direct Selling</li>
                    <li> Live Demonstrations or Projects</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2
                </b>: Advanced Strategies
                </p>
                <ul>
                    <li> Digital & Social Media Marketing for Direct Selling</li>
                    <li> Sales Planning & Target Achievement Strategies</li>
                    <li> Brand Building & Personal Branding</li>
                    <li> Financial Planning & Wealth Management for Direct Sellers</li>
                    <li> Supply Chain & Logistics in Direct Selling</li>
                    <li> Conflict Resolution & Objection Handling</li>
                    <li> Business Growth Strategies & Entrepreneurship</li>
                    <li> Case Study Analysis & Internship</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Disaster Risk Reduction and
                    Management </b> –
                    The Diploma in Disaster Risk Reduction and Management at ARNI School of Business Management &
                    Commerce is designed to equip students with the essential knowledge, skills, and strategies required
                    to effectively respond to and manage disasters. The Diploma in Disaster Risk Reduction and
                    Management consists of two semesters, covering core subjects, practical training, and industry
                    projects.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1
                </b>
                </p>
                <ul>
                    <li> Introduction to Disaster Management and Risk Reduction</li>
                    <li> Disaster Risk Assessment and Mitigation Techniques</li>
                    <li> Humanitarian and Relief Operations</li>
                    <li> Communication Strategies in Disaster Risk Reduction</li>
                    <li> Research Methods in Disaster Risk Management</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2
                </b>
                </p>
                <ul>
                    <li> Disaster Response and Recovery Operations</li>
                    <li> Legal, Ethical, and Policy Frameworks in Disaster Management</li>
                    <li> Risk Financing and Disaster Recovery Funding</li>
                    <li> Community-Based Disaster Risk Reduction</li>
                    <li> Disaster Risk Management in Businesses</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Event Management</b> –
                    The Diploma in Event Management at ARNI School of Business Management & Commerce is designed to
                    equip students with the essential knowledge, skills, and strategies required to students in areas
                    like analyzing, planning, marketing, producing, and evaluating an event. The Diploma in Disaster
                    Event Management consists of two semesters, covering core subjects, practical training, and industry
                    projects.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1
                </b>
                </p>
                <ul>
                    <li> Communication Skills</li>
                    <li> Event Advertising</li>
                    <li> Event Production and Planning</li>
                    <li> Event Marketing</li>
                    <li> Event Accounting</li>
                    <li> Special Event Topics</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2
                </b>
                </p>
                <ul>
                    <li> IT for Event Management</li>
                    <li> Event Risk Management</li>
                    <li> Public Relations</li>
                    <li> Cross-Cultural Management</li>
                    <li> Dissertation I</li>
                    <li> Dissertation II</li>
                </ul>
            </div>

            <hr class="border-dashed" style="border:2px;"/>

            <div class="col-md-12 col-sm-12">
                <p><b class="text-black text-decoration-underline">Diploma in Digital Management </b> –
                    The Diploma in Digital Management at ARNI School of Business Management & Commerce is designed to
                    equip students with the essential knowledge, skills, and strategies required to students in areas
                    like analyzing, planning, marketing, producing, and evaluating an event. The Diploma in Disaster
                    Event Management consists of two semesters, covering core subjects, practical training, and industry
                    projects.
                </p>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 1
                </b>
                </p>
                <ul>
                    <li> Communication Skills</li>
                    <li> Introduction to Digital Marketing</li>
                    <li> Social Media Marketing</li>
                    <li> AdWords & PPC</li>
                    <li> Content Marketing & Copywriting</li>
                </ul>
            </div>

            <div class="col-md-4 col-sm-12">
                <p><b class="text-decoration-underline text-black">Semester 2
                </b>
                </p>
                <ul>
                    <li> SEO</li>
                    <li> Affiliate Marketing</li>
                    <li> Google Analytics</li>
                    <li> Email Marketing</li>

                </ul>
            </div>

        </div>

    </div>
</section>
